<template>
  <VLayout :title="$t('importmedicinesdone.title')">
    <vue-element-loading :active="loading" />
    <div v-if="showcontent">
      <div class="shadow-sm p-4 mb-5 bg-white rounded">
        <div class="pb-2">
          <i18n path="importmedicinesdone.request_sended" tag="span">
            <span place="site_name" class="text-corp-color1">
              <strong>Vooy Market</strong>
            </span>
          </i18n>
        </div>
        <div class="pb-2">{{ $t("importmedicinesdone.pay_to_finish") }}</div>
        <div class="pb-2">
          <i18n path="importmedicinesdone.request_code" tag="span">
            <span place="request_code">
              <strong>{{ importation_cart.human_code }}</strong>
            </span>
          </i18n>
        </div>
        <div class="pb-2">{{ $t("importmedicinesdone.help_line") }}</div>
      </div>
      <VButtonGroup
        :primary_to="{
          name: 'importation_cart_checkout',
          params: { checkout_uuid: importation_cart.checkout },
        }"
        :primary_text="$t('importmedicinesdone.continue_button')"
        hide_secondary
        end
      />
    </div>
  </VLayout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VLayout from "@/layouts/Default";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  name: "import-medicines-done",
  components: {
    VLayout,
    VButtonGroup,
  },
  computed: {
    ...mapState({
      importation_cart: state => state.drugtransaction.importation_cart,
    }),
  },
  data() {
    return {
      loading: false,
      showcontent: false,
    };
  },
  mounted() {
    this.loading = true;
    this.REQUEST_IMPORTATION_CART().then(
      () => {
        if (this.importation_cart.object_status != 2) {
          this.$router.push({ name: "importmedicineshome" });
        }
        this.loading = false;
        this.showcontent = true;
      },
      () => {
        this.loading = false;
      }
    );
  },
  methods: {
    ...mapActions({
      REQUEST_IMPORTATION_CART: "drugtransaction/REQUEST_IMPORTATION_CART",
    }),
  },
  fallbackI18n: {
    messages: {
      und: {
        importmedicinesdone: {
          title: "Request confirmation",
          request_sended: "Your request to {site_name} has been sended.",
          pay_to_finish: "To complete your request, perform the payment.",
          request_code: "Request code: {request_code}",
          help_line: "For any questions, please contact us in customer service",
          continue_button: "Continue",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
